<template>
  <div id="app" class="app">
    <!-- <HelloWorld eric="Ericcito pue"/> -->
    <router-view/>
  </div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'app',
  components: {
    
  },
  created(){
    this.$store.dispatch("getUserByID").then(res => {
      if(res.status == 400 || res.status == 401){
        this.$router.push({name: 'login'})
      }
    })
    if(this.$store.state.login.currentUserId){
      this.$store.dispatch("getBusiness", 1)
    }

    // if(this.$store.state.login.currentUserId){
    //   this.$store.dispatch("getBusiness", )
    // }
  }
}
</script>

<style lang="scss">
@import './assets/styles/main.scss';

.md-overlay{
  z-index: 800 !important;
}
</style>
